import React, {useReducer} from "react";
import MDTypography from "../materialDashboard/components/MDTypography";
import {Icon} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import MDBox from "../materialDashboard/components/MDBox";
import {styled} from "@mui/material/styles";
import Stack from "@mui/material/Stack";


export const FormSectionBox = styled(MDBox)(({theme}) => ({
    padding: theme.spacing(2),
    backgroundColor: '#f8f9fa',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid #ddd',
}));


const FormSection = ({title, children, openDefault=true, error=false, unStyledCollapse}) => {
    const [open, toggle] = useReducer((state) => !state, openDefault);

    return <>
        <MDBox sx={{display: "flex", justifyContent: "space-between", flexDirection: "row"}}
               onClick={() => toggle()}>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize" color={error ? 'error' : 'info'}>
                {title}
            </MDTypography>
            <Icon>{open ? "expand_less" : "expand_more"}</Icon>
        </MDBox>

        <Collapse in={open}>
            {
                !!unStyledCollapse ?
                    <Stack spacing={3}>
                        {children}
                    </Stack>
                    :
                    <FormSectionBox>
                        {children}
                    </FormSectionBox>
            }
        </Collapse>
    </>
}

export default FormSection;